/**
 * Map Prop Values Based On Data Object
 *
 * @param props - Props Values
 * @param data - Source Data
 * @returns Mapped Props Values From Source Data
 */
const mapPropValues = (prop, propData) => {

    // Get value with possible fallback for mobile
    let propValue = propData[prop];
    if (!propValue && prop.endsWith('Mobile')) {
        propValue = propData[prop.replace('Mobile', '')];
    }

    return {
        prop,
        propValueFromData: propValue
    };
};

export default mapPropValues;
